'use client';

import styles from '../../page.module.scss';
import arterix from '../../assets/decos/asterix.svg';
import ArticleCard from './cards/ArtilcleCard';
import PrimaryButton from '../buttons/PrimaryButton';
import Link from 'next/link';

interface ArticlesSectionProps {
  articles: any;
  loading: boolean;
}

const ArticlesSection: React.FC<ArticlesSectionProps> = ({ articles, loading }) => {
  const articlesContent = [...articles].reverse();

  return (
    <div id="leenos" className={styles.articleSectionContainer}>
      <section>
        <div className={styles.articleSectionHeader}>
          <div>
            <img src={arterix.src} alt="" />
            <h2 className={styles.title}>Prensa</h2>
            <p className={styles.text}>
              Sección de entrevistas a nuestros autores y reseñas de nuestros libros.{' '}
            </p>
          </div>
          <img src="/assets/images/prensa.png" alt="mujer leyendo el diario" />
        </div>
        <div className={styles.articleSectionGrid}>
          {!loading
            ? articlesContent &&
              articlesContent.map(
                (art: any, index: number) =>
                  art.published &&
                  index < 4 && (
                    <div key={index}>
                      <ArticleCard
                        title={art.mainTitle}
                        author={art.author}
                        image={art.cardImage}
                        href={`/articulo/${art.slug}`}
                      />
                    </div>
                  )
              )
            : [1, 2, 3, 4].map((_, index: number) => (
                <div
                  key={index}
                  className={`${styles.articleCard} ${styles.cardLoader} ${styles.articleCardLoader}`}
                ></div>
              ))}
        </div>
      </section>
      <br />
      <Link href={'/articulos'}>
        <PrimaryButton primary={false} text="Ver todos los artículos" />
      </Link>
    </div>
  );
};

export default ArticlesSection;
